import React, { useState, createContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import Confirm from './common/dialogs/Confirm';
import Info from './common/dialogs/Info';
import Notification from './common/notification/Notification';
import Header from './layout/header/Header';
import Footer from './layout/footer/Footer';
import Homepage from './pages/homepage/Homepage';
import About from './pages/about/About';
import Services from './pages/services/Services';
import Team from './pages/team/Team';
import Portfolio from './pages/portfolio/Portfolio';
import Products from './pages/products/Products';
import Product from './pages/products/Product';
import Contact from './pages/contact/Contact';
import './App.css';
import './index.css';

export const AppContext = createContext({});

function App() {
  const [confirm, setConfirm] = useState();
  const [info, setInfo] = useState();
  const [notifications, setNotifications] = useState([]);

  const openInfo = (title, message, closeCaption) => {
    setInfo({
      title,
      message,
      closeCaption,
      onClose: () => {
        setInfo(undefined);
      },
    });
  };
  const openConfirm = (
    title,
    message,
    cancelCaption,
    confirmCaption,
    onConfirm,
    onCancel
  ) => {
    setConfirm({
      title,
      message,
      cancelCaption,
      confirmCaption,
      onConfirm: () => {
        let dontClose = undefined;
        if (onConfirm) {
          dontClose = onConfirm();
        }
        if (typeof dontClose !== 'boolean' || dontClose !== true) {
          setConfirm(undefined);
        }
      },
      onCancel: () => {
        if (onCancel) {
          onCancel();
        }
        setConfirm(undefined);
      },
    });
  };

  const closeConfirm = () => {
    setConfirm(undefined);
  };

  const showNotification = (type, body, delayInSeconds, header) => {
    const newNotification = {
      id: uuid(),
      type,
      body,
      delayInSeconds,
      header,
    };
    setNotifications([...notifications].concat(newNotification));
  };

  /**
   * Easy selector helper function
   */
  const select = (el, all = false) => {
    el = el.trim();
    if (all) {
      return [...document.querySelectorAll(el)];
    } else {
      return document.querySelector(el);
    }
  };

  /**
   * Easy event listener function
   */
  const on = (type, el, listener, all = false) => {
    let selectEl = select(el, all);
    if (selectEl) {
      if (all) {
        selectEl.forEach((e) => e.addEventListener(type, listener));
      } else {
        selectEl.addEventListener(type, listener);
      }
    }
  };

  /**
   * Easy on scroll event listener
   */
  const onscroll = (el, listener) => {
    el.addEventListener('scroll', listener);
  };

  /**
   * Scrolls to an element with header offset
   */
  const scrollto = (el) => {
    let header = select('#header');
    let offset = header.offsetHeight;

    if (!header.classList.contains('header-scrolled')) {
      offset -= 16;
    }

    let elementPos = select(el).offsetTop;
    window.scrollTo({
      top: elementPos - offset,
      behavior: 'smooth',
    });
  };

  const addListeners = () => {
    /**
     * Initiate glightbox
     */
    // eslint-disable-next-line no-unused-vars
    const glightbox = window.GLightbox({
      selector: '.glightbox',
    });

    /**
     * Initiate portfolio lightbox
     */
    // eslint-disable-next-line no-unused-vars
    const portfolioLightbox = window.GLightbox({
      selector: '.portfolio-lightbox',
    });

    /**
     * Navbar links active state on scroll
     */
    // let navbarlinks = select('#navbar .scrollto', true);
    // const navbarlinksActive = () => {
    //   let position = window.scrollY + 200;
    //   navbarlinks.forEach((navbarlink) => {
    //     if (!navbarlink.hash) return;
    //     let section = select(navbarlink.hash);
    //     if (!section) return;
    //     if (
    //       position >= section.offsetTop &&
    //       position <= section.offsetTop + section.offsetHeight
    //     ) {
    //       navbarlink.classList.add('active');
    //     } else {
    //       navbarlink.classList.remove('active');
    //     }
    //   });
    // };
    // //window.addEventListener('load', navbarlinksActive);
    // onscroll(document, navbarlinksActive);
    // navbarlinksActive();

    /**
     * Toggle .header-scrolled class to #header when page is scrolled
     */
    // let selectHeader = select('#header');
    // if (selectHeader) {
    //   const headerScrolled = () => {
    //     if (window.scrollY > 100) {
    //       selectHeader.classList.add('header-scrolled');
    //     } else {
    //       selectHeader.classList.remove('header-scrolled');
    //     }
    //   };
    //   //window.addEventListener('load', headerScrolled);
    //   onscroll(document, headerScrolled);
    //   headerScrolled();
    // }

    /**
     * Back to top button
     */
    let backtotop = select('.back-to-top');
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add('active');
        } else {
          backtotop.classList.remove('active');
        }
      };
      //window.addEventListener('load', toggleBacktotop);
      onscroll(document, toggleBacktotop);
      toggleBacktotop();
    }

    /**
     * Mobile nav toggle
     */
    // eslint-disable-next-line no-unused-vars
    // on('click', '.mobile-nav-toggle', function (e) {
    //   select('#navbar').classList.toggle('navbar-mobile');
    //   this.classList.toggle('bi-list');
    //   this.classList.toggle('bi-x');
    // });

    /**
     * Mobile nav dropdowns activate
     */
    // on(
    //   'click',
    //   '.navbar .dropdown > a',
    //   function (e) {
    //     if (select('#navbar').classList.contains('navbar-mobile')) {
    //       e.preventDefault();
    //       this.nextElementSibling.classList.toggle('dropdown-active');
    //     }
    //   },
    //   true
    // );

    /**
     * Scrool with ofset on links with a class name .scrollto
     */
    // on(
    //   'click',
    //   '.scrollto',
    //   function (e) {
    //     if (select(this.hash)) {
    //       e.preventDefault();

    //       let navbar = select('#navbar');
    //       if (navbar.classList.contains('navbar-mobile')) {
    //         navbar.classList.remove('navbar-mobile');
    //         let navbarToggle = select('.mobile-nav-toggle');
    //         navbarToggle.classList.toggle('bi-list');
    //         navbarToggle.classList.toggle('bi-x');
    //       }
    //       scrollto(this.hash);
    //     }
    //   },
    //   true
    // );

    /**
     * Scroll with ofset on page load with hash links in the url
     */
    if (window.location.hash) {
      if (select(window.location.hash)) {
        scrollto(window.location.hash);
      }
    }
    // window.addEventListener('load', () => {
    //   if (window.location.hash) {
    //     if (select(window.location.hash)) {
    //       scrollto(window.location.hash);
    //     }
    //   }
    // });

    /**
     * Porfolio isotope and filter
     */
    let portfolioContainer = select('.portfolio-container');
    if (portfolioContainer) {
      let portfolioIsotope = new window.Isotope(portfolioContainer, {
        itemSelector: '.portfolio-item',
      });

      let portfolioFilters = select('#portfolio-flters li', true);

      on(
        'click',
        '#portfolio-flters li',
        function (e) {
          e.preventDefault();
          portfolioFilters.forEach(function (el) {
            el.classList.remove('filter-active');
          });
          this.classList.add('filter-active');

          portfolioIsotope.arrange({
            filter: this.getAttribute('data-filter'),
          });
        },
        true
      );
    }
    // window.addEventListener('load', () => {
    //   let portfolioContainer = select('.portfolio-container');
    //   if (portfolioContainer) {
    //     let portfolioIsotope = new window.Isotope(portfolioContainer, {
    //       itemSelector: '.portfolio-item',
    //     });

    //     let portfolioFilters = select('#portfolio-flters li', true);

    //     on(
    //       'click',
    //       '#portfolio-flters li',
    //       function (e) {
    //         e.preventDefault();
    //         portfolioFilters.forEach(function (el) {
    //           el.classList.remove('filter-active');
    //         });
    //         this.classList.add('filter-active');

    //         portfolioIsotope.arrange({
    //           filter: this.getAttribute('data-filter'),
    //         });
    //       },
    //       true
    //     );
    //   }
    // });

    /**
     * Portfolio details slider
     */
    new window.Swiper('.portfolio-details-slider', {
      speed: 400,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });

    /**
     * Testimonials slider
     */
    new window.Swiper('.testimonials-slider', {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  };

  // const removeListeners = () => {
  //   /**
  //    * Navbar links active state on scroll
  //    */
  //   let navbarlinks = select('#navbar .scrollto', true);
  //   const navbarlinksActive = () => {
  //     let position = window.scrollY + 200;
  //     navbarlinks.forEach((navbarlink) => {
  //       if (!navbarlink.hash) return;
  //       let section = select(navbarlink.hash);
  //       if (!section) return;
  //       if (
  //         position >= section.offsetTop &&
  //         position <= section.offsetTop + section.offsetHeight
  //       ) {
  //         navbarlink.classList.add('active');
  //       } else {
  //         navbarlink.classList.remove('active');
  //       }
  //     });
  //   };
  //   window.removeEventListener('load', navbarlinksActive);
  //   onscroll(document, navbarlinksActive);

  //   /**
  //    * Toggle .header-scrolled class to #header when page is scrolled
  //    */
  //   let selectHeader = select('#header');
  //   if (selectHeader) {
  //     const headerScrolled = () => {
  //       if (window.scrollY > 100) {
  //         selectHeader.classList.add('header-scrolled');
  //       } else {
  //         selectHeader.classList.remove('header-scrolled');
  //       }
  //     };
  //     window.removeEventListener('load', headerScrolled);
  //     onscroll(document, headerScrolled);
  //   }

  //   /**
  //    * Back to top button
  //    */
  //   let backtotop = select('.back-to-top');
  //   if (backtotop) {
  //     const toggleBacktotop = () => {
  //       if (window.scrollY > 100) {
  //         backtotop.classList.add('active');
  //       } else {
  //         backtotop.classList.remove('active');
  //       }
  //     };
  //     window.removeEventListener('load', toggleBacktotop);
  //     onscroll(document, toggleBacktotop);
  //   }

  //   /**
  //    * Mobile nav toggle
  //    */
  //   // eslint-disable-next-line no-unused-vars
  //   on('click', '.mobile-nav-toggle', function (e) {
  //     select('#navbar').classList.toggle('navbar-mobile');
  //     this.classList.toggle('bi-list');
  //     this.classList.toggle('bi-x');
  //   });

  //   /**
  //    * Mobile nav dropdowns activate
  //    */
  //   on(
  //     'click',
  //     '.navbar .dropdown > a',
  //     function (e) {
  //       if (select('#navbar').classList.contains('navbar-mobile')) {
  //         e.preventDefault();
  //         this.nextElementSibling.classList.toggle('dropdown-active');
  //       }
  //     },
  //     true
  //   );

  //   /**
  //    * Scrool with ofset on links with a class name .scrollto
  //    */
  //   on(
  //     'click',
  //     '.scrollto',
  //     function (e) {
  //       if (select(this.hash)) {
  //         e.preventDefault();

  //         let navbar = select('#navbar');
  //         if (navbar.classList.contains('navbar-mobile')) {
  //           navbar.classList.remove('navbar-mobile');
  //           let navbarToggle = select('.mobile-nav-toggle');
  //           navbarToggle.classList.toggle('bi-list');
  //           navbarToggle.classList.toggle('bi-x');
  //         }
  //         scrollto(this.hash);
  //       }
  //     },
  //     true
  //   );

  //   /**
  //    * Scroll with ofset on page load with hash links in the url
  //    */
  //   window.removeEventListener('load', () => {
  //     if (window.location.hash) {
  //       if (select(window.location.hash)) {
  //         scrollto(window.location.hash);
  //       }
  //     }
  //   });

  //   /**
  //    * Porfolio isotope and filter
  //    */
  //   window.removeEventListener('load', () => {
  //     let portfolioContainer = select('.portfolio-container');
  //     if (portfolioContainer) {
  //       let portfolioIsotope = new window.Isotope(portfolioContainer, {
  //         itemSelector: '.portfolio-item',
  //       });

  //       let portfolioFilters = select('#portfolio-flters li', true);

  //       on(
  //         'click',
  //         '#portfolio-flters li',
  //         function (e) {
  //           e.preventDefault();
  //           portfolioFilters.forEach(function (el) {
  //             el.classList.remove('filter-active');
  //           });
  //           this.classList.add('filter-active');

  //           portfolioIsotope.arrange({
  //             filter: this.getAttribute('data-filter'),
  //           });
  //         },
  //         true
  //       );
  //     }
  //   });

  //   /**
  //    * Portfolio details slider
  //    */
  //   new window.Swiper('.portfolio-details-slider', {
  //     speed: 400,
  //     loop: true,
  //     autoplay: {
  //       delay: 5000,
  //       disableOnInteraction: false,
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       type: 'bullets',
  //       clickable: true,
  //     },
  //   });

  //   /**
  //    * Testimonials slider
  //    */
  //   new window.Swiper('.testimonials-slider', {
  //     speed: 600,
  //     loop: true,
  //     autoplay: {
  //       delay: 5000,
  //       disableOnInteraction: false,
  //     },
  //     slidesPerView: 'auto',
  //     pagination: {
  //       el: '.swiper-pagination',
  //       type: 'bullets',
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       320: {
  //         slidesPerView: 1,
  //         spaceBetween: 20,
  //       },

  //       1200: {
  //         slidesPerView: 3,
  //         spaceBetween: 20,
  //       },
  //     },
  //   });
  // };

  const defaultErrorDelayInSeconds = 10;

  const errorNotification = (error, header) => {
    let status = error?.response?.status;
    if (!status) {
      status = error?.response?.data?.statusCode;
    }
    if (!error.response) {
      if (error.isAxiosError && error.message === 'Network Error') {
        status = -1;
      } else {
        status = 0;
      }
    }
    switch (status) {
      case 500:
        showNotification(
          'error',
          'Server error occured. Please try again. If error persists contact admin.',
          defaultErrorDelayInSeconds,
          header || 'Server error'
        );
        break;
      case 404:
        showNotification(
          'error',
          'Requested resource not found.',
          defaultErrorDelayInSeconds,
          header || 'Not found'
        );
        break;
      case 403:
        showNotification(
          'error',
          'You do not have authorization to see this resource.',
          defaultErrorDelayInSeconds,
          header || 'Unauthorized'
        );
        break;
      case 401:
        showNotification(
          'error',
          'Your login session has expired. Please logout and login again.',
          defaultErrorDelayInSeconds,
          header || 'Session expired'
        );
        break;
      case 400:
        showNotification(
          'error',
          'Some of the request parameters are wrong.',
          defaultErrorDelayInSeconds,
          header || 'Bad request'
        );
        break;
      case -1:
        showNotification(
          'error',
          'Server is down. Try again latter.',
          defaultErrorDelayInSeconds,
          header || 'Server is unavailable'
        );
        break;
      default:
        showNotification(
          'error',
          'Server is down. Try again latter.',
          defaultErrorDelayInSeconds,
          header || 'Server is unavailable'
        );
        break;
    }
  };

  return (
    <AppContext.Provider
      value={{
        showNotification,
        openInfo,
        openConfirm,
        closeConfirm,
        addListeners,
        //removeListeners,
        errorNotification,
      }}
    >
      <Info
        visible={!!info}
        title={info && info.title}
        message={info && info.message}
        closeCaption={info && info.closeCaption}
        onClose={info && info.onClose}
      />
      <Confirm
        visible={!!confirm}
        title={confirm && confirm.title}
        message={confirm && confirm.message}
        cancelCaption={confirm && confirm.cancelCaption}
        confirmCaption={confirm && confirm.confirmCaption}
        onClose={confirm && confirm.onCancel}
        onSave={confirm && confirm.onConfirm}
      />
      <Notification
        notifications={notifications}
        setNotifications={setNotifications}
      />
      <div className={'content-wrapper'}>
        <Header />
        <div className="main-content-wrapper">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="team" element={<Team />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="products">
              <Route path="" element={<Products />} />
              <Route path=":id" element={<Product />} />
            </Route>
            <Route path="contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
        <a
          href="#"
          className="back-to-top d-flex align-items-center justify-content-center"
        >
          <i className="bi bi-arrow-up-short"></i>
        </a>
      </div>
    </AppContext.Provider>
  );
}

export default App;
